// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "EditCustomSupplier" + "." + "7068c06c" + ".css";
};